import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { mergeMap } from 'rxjs/operators';
import { flatten } from '@angular/compiler';
import { MsalService } from '@azure/msal-angular';
import { SilentRequest } from '@azure/msal-browser';
import { environment } from 'src/environments/environment.demo';

@Component({
  selector: 'app-assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.scss'],
})
export class AssetsComponent implements OnInit, OnDestroy {
  searchText = '';
  image = '../../../../assets/images/assets-banner.jpg';
  bannerTitle = 'Assets';
  sortedBy = { id: 1, displayName: 'Alphabetical' };
  assetCount: number = 0;
  defaultFilters: any = {};
  selectedFilters: any = {};
  routeParam: any = {};
  assetList: any;
  assetListCopy: any;
  filterArray: any;
  filterChips: any = [];
  isDropdownOpen: boolean;
  isIntervalSet: boolean = false;
  interval: any;

  sortByDropdown = [
    { id: 1, displayName: 'Alphabetical' },
    { id: 2, displayName: 'Recent' },
    { id: 3, displayName: 'Most Viewed' },
  ];
  username: any;
  showCloseicon: string;
  assetsResponse: boolean;
  apiTimer: any;

  requesttoken: SilentRequest = {
    scopes: [environment.clientId + '/user.read'],
    account: undefined,
    // account: this.msalService.instance.getAllAccounts()[0]
  };
  constructor(
    private authService: MsalService,
    private _appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this._appService.checkRefreshTokenValidity();
    this.requesttoken.account = this.authService.instance.getAllAccounts()[0]
        this.authService.acquireTokenSilent(this.requesttoken).subscribe(result => {
          // console.log("SilentToken response in AssetsComponent...", result);
          sessionStorage.setItem('accessToken', result.accessToken);
          this._appService.jwtAuthorizationToken=result.accessToken;
          this.loadData();
        })
  }
  loadData(){
    this._appService.getUsername().subscribe(userdata => this.username = userdata);
    this.apiTimer = setInterval(()=>{
    this._appService
      .getAssetFilters()
      .pipe(
        mergeMap((filterRes: any) => {
          // console.log("filterResponse--->",filterRes);
          this.filterArray = filterRes;
          return this._appService.getAllAssets(0, null, this.username);
        })
      )
      .subscribe((assetRes: any) => {
        if (assetRes && !!assetRes.length) {
          this.assetsResponse = true;
          this.assetList = assetRes;
          this.assetCount = this.assetList.length;
          this.assetListCopy = [...this.assetList];

          if (
            this.activatedRoute.snapshot.params.hasOwnProperty('search_text')
          ) {
            this.searchText = this.activatedRoute.snapshot.params.search_text;
          }
          if (this.activatedRoute.snapshot.params.hasOwnProperty('sort')) {
            this.sortedBy.displayName = this.activatedRoute.snapshot.params.sort;
            this.sortByDropdown.forEach((elem: any) => {
              if (elem.displayName == this.sortedBy.displayName) this.sortedBy.id = elem.id;
            })
            this.onItemsChange(this.sortedBy)
          }
          if (
            this.activatedRoute.snapshot.params.hasOwnProperty(
              'selected_filters'
            )
          ) {
            this.selectedFilters = JSON.parse(
              this.activatedRoute.snapshot.params.selected_filters
            );
            this.filterSelected({ filters: this.selectedFilters });

            if ('filter_chips' in sessionStorage) {
              this.filterChips = JSON.parse(
                <string>sessionStorage.getItem('filter_chips')
              );
            }
          } else {
            sessionStorage.removeItem('filter_chips');
          }
          this.setFilterData(this.selectedFilters);
        }
        else{this.assetsResponse = true;
          this.assetList = [];
          this.assetCount = 0;
          this.assetListCopy = [...this.assetList];}

        if(this.assetList){
          clearInterval(this.apiTimer);
        }
      });
    },2000)
  }

  setFilterData(selectedFilters: any) {
    this.filterArray.forEach((element: any) => {
      element['filter_subject'] = `${element.FilterTitle.replaceAll(
        ' ',
        '_'
      )}_Id`;

      let otherFilter = element.filterlist.splice(element.filterlist.findIndex((item: any) => item.filterValue.toLowerCase() == "others"), 1);

      element.filterlist.sort((a: any, b: any) => {
        if (a['filterValue'].toUpperCase() > b['filterValue'].toUpperCase())
          return 1;
        if (a['filterValue'].toUpperCase() < b['filterValue'].toUpperCase())
          return -1;

        return 0;
      });

      element.filterlist.push(otherFilter[0])

      element.filterlist.forEach((item: any) => {
        if (selectedFilters[element.filter_subject] != undefined) {
          if (selectedFilters[element.filter_subject].includes(item.filterId)) {
            item.isSelected = true;
            this.defaultFilters[item.filterValue] = true;
            if (this.activatedRoute.snapshot.params.hasOwnProperty(
              'selected_filters'
            ) && !('filter_chips' in sessionStorage)) {
              this.filterChips.push({ id: element.filterId, value: item.filterValue, type: element.filter_subject })
            }
          } else {
            item.isSelected = false;
            this.defaultFilters[item.filterValue] = false;
          }
        } else {
          item.isSelected = false;
          this.defaultFilters[item.filterValue] = false;
        }
      });
    });
  }
  searchKeyUp() {
    this.showCloseicon = "true"
  }

  filterSelected(eventData: any) {
    this.selectedFilters = eventData.filters;
    if (eventData.hasOwnProperty('chips')) {
      this.filterChips = eventData.chips;
    }
    // this.defaultFilters = eventData.default;
    let filteredAssets: any = [];
    this.assetListCopy = [];
    if (JSON.stringify(this.selectedFilters) != '{}') {
      Object.keys(this.selectedFilters).forEach((item) => {
        for (let i = 0; i < this.assetList.length; i++) {
          if (this.selectedFilters[item].includes(this.assetList[i][item])) {
            filteredAssets.push(this.assetList[i]);
          }
        }
        this.assetListCopy = [
          ...new Set([...this.assetListCopy, ...filteredAssets]),
        ];
        // filteredAssets = this.assetList.filter((asset: any) => {
        //   return selectedFilter[item].includes(asset[item]);
        // });
        this.assetListCopy = [...new Set([...filteredAssets])];
      });
    } else {
      this.assetListCopy = [...this.assetList];
    }

    // this.setRouteParams();
    this.onItemsChange(this.sortedBy)

  }

  setRouteParams() {
    if (Object.keys(this.selectedFilters).length > 0 && this.searchText && this.sortedBy.id !== 1) {
      this.routeParam = {
        selected_filters: JSON.stringify(this.selectedFilters),
        search_text: this.searchText,
        sort: this.sortedBy.displayName,
      };
    } else if (Object.keys(this.selectedFilters).length > 0 && this.searchText) {
      this.routeParam = {
        selected_filters: JSON.stringify(this.selectedFilters),
        search_text: this.searchText,
      };
    }
    else if (JSON.stringify(this.selectedFilters) != '{}' && this.sortedBy.id !== 1) {
      this.routeParam = {
        selected_filters: JSON.stringify(this.selectedFilters),
        sort: this.sortedBy.displayName,
      };
    } else if (this.searchText && this.sortedBy.id !== 1) {
      this.routeParam = { search_text: this.searchText, sort: this.sortedBy.displayName, };
    } else if (JSON.stringify(this.selectedFilters) != '{}') {
      this.routeParam = {
        selected_filters: JSON.stringify(this.selectedFilters),
      };
    } else if (this.sortedBy.id !== 1) {
      this.routeParam = { sort: this.sortedBy.displayName, };
    } else if (this.searchText) {
      this.routeParam = { search_text: this.searchText, };
    }
    else {
      this.routeParam = {};
    }
    this.router.navigate([this.routeParam], {
      replaceUrl: true,
      relativeTo: this.activatedRoute,
    });
  }

  removeFilter(filter: any) {
    this.filterChips.splice(this.filterChips.findIndex((item: any) => item.type == filter.type && item.id == filter.id), 1);
    this.filterArray.filter((item: any) => item.filter_subject == filter.type)[0].filterlist.forEach((element: any) => {
      if (element.filterId == filter.id) {
        element.isSelected = false;
      }
    });
    this.selectedFilters[filter.type].splice(this.selectedFilters[filter.type].indexOf(filter.id), 1)
    if (this.selectedFilters[filter.type].length == 0) {
      delete this.selectedFilters[filter.type];
    }
    this.filterSelected({ filters: this.selectedFilters })
  }

  clearAllFilter() {
    this.selectedFilters = {};
    this.filterChips = [];
    this.assetListCopy = [...this.assetList];
    this.filterArray.forEach((element: any) => {
      element.filterlist.forEach((item: any) => {
        item.isSelected = false;
      });
    });
    this.onItemsChange(this.sortedBy)
    // this.setRouteParams();
  }

  onItemsChange(event: any) {
    this.isDropdownOpen = false
    this.sortedBy = event;
    if (event.id == 1) {
      this.assetListCopy.sort((a: any, b: any) => {
        if (a['Asset_Name'].toUpperCase() > b['Asset_Name'].toUpperCase())
          return 1;
        if (a['Asset_Name'].toUpperCase() < b['Asset_Name'].toUpperCase())
          return -1;

        return 0;
      });
    } else if (event.id == 2) {
      this.assetListCopy.sort((a: any, b: any) => {
        const first: any = new Date(a['Updated_On']);
        const second: any = new Date(b['Updated_On']);
        return second - first;
      });
    } else if (event.id == 3) {
      this.assetListCopy.sort((a: any, b: any) => {
        return b['View_Count'] - a['View_Count'];
      });
    }
    this.setRouteParams();
  }

  onBoookmarkClick(data: any) {
    this._appService
      .addAssetBookmarked(data.isBookmarked, data.id, this.username)
      .subscribe();
  }

  clearSearch() {
    this.searchText = '';
    this.setRouteParams();
  }

  openDropdown() {
    this.isDropdownOpen = true
    if (!this.isIntervalSet) {
      this.interval = setInterval(() => {
        if (!document.getElementById('ddMenu')?.classList.contains('active') && this.isDropdownOpen) {
          this.isDropdownOpen = false
        }
      }, 1500)

      this.isIntervalSet = true
    }
  }

  ngOnDestroy() {
    clearInterval(this.interval)
  }
}
